import type { CommandFactory } from './types'

export const identityCommand: CommandFactory = (context) => ({
  id: 'identity',
  name: 'identity',
  description: 'Create an AI identity from a description',
  acceptsArgs: true,
  handler: async (args?: string) => {
    if (!args || args.trim() === '') {
      context.onDisplayMessage?.({
        role: 'command',
        content:
          'Please provide an identity description. Usage: `/identity <your identity description>`',
        timestamp: new Date(),
      })
      return
    }

    // Submit a message that will prompt the AI to use the create_identity tool
    context.onSubmitMessage?.(
      `Use the create_identity tool to create a new AI identity based on this description: ${args.trim()}. The identity should include a custom system prompt that defines the AI's personality, expertise, and behavior.`
    )
  },
})
